'use strict';

bbw.directive.bbwIsTouchClass = ['bbw.LayoutTypeSvc', function(layoutType) {
    return {
        compile: function(element, attrs) {
            if (angular.isString(attrs.bbwIsTouchClass) && attrs.bbwIsTouchClass[0] == '!') {
                if (!layoutType.hasTouch()) {
                    element.addClass(attrs.bbwIsTouchClass.substr(1));
                }
            } else {
                if (layoutType.hasTouch()) {
                    element.addClass(attrs.bbwIsTouchClass || 'has-touch');
                }
            }
        }
    };
}];
